/* istanbul ignore file */
import React from 'react';
import compose from 'lodash/fp/compose';
import { withCustomer } from '@catalogo/core-connect/customer';
import AmeText from '@catalogo/ui-americanas-desktop-svg/ame-text.svg';
import styled, { css } from 'styled-components';
import { withRouter } from 'react-router';
import { replaceUrlParams } from '@catalogo/service-americanas-product/src/helpers/url';

export const BuyAme = ({ fullWidth = true, history }) => (
  <BuyButton fullWidth={fullWidth} onClick={replaceUrlParams(history, '#modal-ame-checkout', false)}>
    <AmeButtonText fullWidth={fullWidth}>comprar com</AmeButtonText>
    <IconAmeText width="60" height="20" />
  </BuyButton>
);

const BuyButton = styled.a`
  border: 2px solid ${({ theme }) => theme.primaryColor};
  border-radius: 12px;
  height: 44px;
  background: #fff;
  display: inline-grid;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding: 3px 12px;
  position: relative;
  width: 175px;
  font-size: 12px;

  ${({ fullWidth }) =>
    fullWidth &&
    css`
      height: 54px;
      width: 100%;
      margin-top: 10px;
      display: flex;
      padding: 15px 12px;
      font-size: 16px;
    `}

  @media (min-width: 660px) {
    width: 300px;
    margin: 10px auto 0px auto;
  }
`;

const AmeButtonText = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.primaryColor};
  font-size: ${({ fullWidth }) => (fullWidth ? '18px' : '12px')};
`;

const IconAmeText = styled(AmeText)`
  margin: 0 10px;
`;

export default compose(withRouter, withCustomer)(BuyAme);
